module.exports = __webpack_public_path__ + "media/images/favicons/alteryxconnect-dc6af99a3db4d94539515802d63240766514374b974e0545b071a0dfed5ea311.ico";